import { Theme } from '@mui/material/styles';

export const styles = {
  subscriptionBillingLoading: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapper: {
    position: 'relative',
    display: 'flex',
  },
  icon: {
    position: 'absolute',
    fontSize: '60px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  },
  progress: (theme: Theme) => ({
    color: theme.palette.text.primary,
  }),
  errorWrapper: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '81px',
    height: '81px',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.error.main}`,
  }),
  successWrapper: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '81px',
    height: '81px',
    borderRadius: '50%',
    border: `1px solid ${theme.palette.success.main}`,
  }),
};
